module.exports = __webpack_public_path__ + "img/IMG_8983.bab97949.jpg";